import { render, staticRenderFns } from "./FeedbackShow.vue?vue&type=template&id=ba62f592&scoped=true"
import script from "./FeedbackShow.vue?vue&type=script&lang=ts"
export * from "./FeedbackShow.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackShow.vue?vue&type=style&index=0&id=ba62f592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba62f592",
  null
  
)

export default component.exports